<template>
<div class="actbtnBG">
<!-- Button trigger modal -->
<input type="checkbox" name="" id="xmasBtnBG-active">
<div class="xmasBtnBG">
  <div class="xmasBtn" data-toggle="modal" data-target="#actBtnModal">
  </div>
  <label for="xmasBtnBG-active">
    <i class="fas fa-angle-right"></i>
  </label>
</div>
<!-- Modal -->
<div class="modal fade mt-5" id="actBtnModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-md overflow" role="document">
    <div class="modal-content">
      <div class="modal-body">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <br>
      <br>
        <div class="xmascontainer">
          <iframe src="https://www.youtube.com/embed/AyqGablMuaE?si=hIBYtG3pRNI9csr9" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen class="xmasvideo"></iframe>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</template>

<script>
export default {
  name: 'actBtn',
  data () {
    return {
      fullWidth: document.body.clientWidth
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.modal-dialog{
  overflow-y: initial !important
}

.modal-body{
  height: 70vh;
  overflow-y: scroll;
  //overflow-y: auto;
  .xmascontainer {
    position: relative;
    aspect-ratio: 16 / 9;
    width: 40vw;
    margin: 0 auto;
    top: 5vh;
  }
  .xmasvideo {
    position: absolute;
    width: 100%;
    height: 100%;
  }
}
.xmasBtnBG {
  bottom: 90px;
  left: 100%;
  display: flex;
  flex-direction: column; //主軸
  position: fixed;
  transform: translateX(-100%);
  transition: 0.5s; // 側邊選單收合的時間差
  z-index: 10;
  label {
    width: 25px;
    height: 25px;
    line-height: 25px;
    background-color: #f29ca6;
    color: #b1d3ec;
    position: absolute;
    right: 190px;
    top: 0;
    bottom: 100px;
    margin: auto;
    text-align: center;
    align-items: center;
    border-radius: 50%;
  }
}
.xmasBtn{
  background: url("/images/decoration/actBTN.gif"), rgba(111,111,111, 0);
  background-size: contain;
  background-repeat: no-repeat;
  width: 170px;
  height: 170px;
  cursor: pointer;
}
#xmasBtnBG-active:checked + .xmasBtnBG {
  transform: translateX(0);

 // 當我點擊 sideMenu 時，checkbox 會啟動 id，讓側邊選單跑出來
  label .fas {
  transform: scaleX(-1); // 使 label 裡的圖案橫向反轉
  }
}

#xmasBtnBG-active {
  position: fixed;
  opacity: 0; //使 checkbox 變透明
  z-index: -1; // 為了保險不要讓該功能還選得到，可將其排序往後跳
}
a,
label {
  cursor: pointer;
}
@media (max-width: 800px) {
  .modal-body{
    height: 60vh;
    //overflow-y: auto;
  .xmascontainer {
    width: 50vw;
    top: 5vh;

  }
  }
}
@media (max-width: 641px) {
  .xmasBtn {
    width: 80px;
    height: 80px;
  }
  .xmasBtnBG {
    label {
      right: 85px;
  }
  }
  .modal{
    top: 20vh;
  }
  .modal-body{
    height: 50vh;
    //overflow-y: auto;
  .xmascontainer {
    width: 80vw;
    top: 2vh;

  }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/actBtn2.vue